import { KAKAO_JAVASCRIPT_KEY } from "./kakao.config";

export const isKakaoShareAvailable = (): boolean =>
  typeof window !== "undefined" && KAKAO_JAVASCRIPT_KEY.length > 0;
